
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const handleLinkClick = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="https://static.readdy.ai/image/75eaeb23002452c01ddd137892cf07ae/7775d7eb5d42654a0b94aeae1dc3ce4b.png" 
              alt="DP Crypt" 
              className="h-8 w-auto"
            />
            <p className="text-gray-400 text-sm">
              {t('footer.description')}
            </p>
          </div>

          {/* Buy Crypto */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.buyCrypto')}</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleLinkClick('/purchase')}
                  className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                >
                  USDT
                </button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.products')}</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleLinkClick('/aurora-card')}
                  className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                >
                  {t('footer.auroraCard')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleLinkClick('/lending')}
                  className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                >
                  Lending
                </button>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.support')}</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleLinkClick('/contact')}
                  className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                >
                  {t('footer.contact')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleLinkClick('/about')}
                  className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                >
                  {t('footer.about')}
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Information */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="text-gray-400 text-xs leading-relaxed space-y-4 mb-8">
            <p>
              Dream Pulse Limited LTD, is a limited company registered at Comoros Union, with Limited company number HY01023047 and having its registered office at Bonovo Road, Fomboni, Island of Mohéli, Comoros Union.
            </p>
            <p>
              <strong className="text-gray-300">INTERNATIONAL BROKERAGE and CLEARING HOUSE LICENSE:</strong> T2023392
            </p>
            <p>
              <strong className="text-gray-300">Legal Disclaimer:</strong> CFDs are intricate financial instruments that carry a high risk of rapid monetary loss due to leverage. It's important to assess whether you comprehend how CFDs operate and if you can afford the considerable risk of losing your capital. Please thoroughly read and understand our Risk Disclosure before proceeding. The content on this website is of a general nature and should not be construed as investment advice, a recommendation, or a solicitation to participate in any investment activities. We urge you to carefully review our legal documents and fully grasp the associated risks before making any trading choices. Seeking independent advice is strongly encouraged.
            </p>
            <p>
              <strong className="text-gray-300">Restricted Regions:</strong> The Dream Pulse Limited LTD brand does not offer services to residents of specific jurisdictions, including but not limited to the United States of America, Canada, Cuba, Islamic Republic of Iran, Sudan, Syria, and the Democratic Republic of Korea.
            </p>
            <p>
              The website and its services are not intended for use by individuals in countries where such use is prohibited by local laws or regulations. If you access this website from a country where its use may be prohibited, it is your responsibility to ensure compliance with local laws and regulations. The Dream Pulse Limited LTD brand does not guarantee that the information on its website is suitable for all jurisdictions.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-wrap items-center space-x-6">
            <p className="text-gray-400 text-sm">© 2025 DP Crypt. {t('footer.rights')}</p>
            <button 
              onClick={() => handleLinkClick('/privacy-policy')}
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              {t('footer.privacy')}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
